import Head from "next/head";
import { NextRouter, useRouter } from "next/router";
import { FC, ReactNode } from "react";
import { isMobile } from "react-device-detect";
import { useSession } from "next-auth/react";
import { APP_NAME } from "utils/constants";
import LoadingScreen from "./LoadingScreen";
import MainLayout from "./MainLayout";
import AppPage from "@components/AppPage";
import { LocalStorageHelper } from "utils/localstorage";
import I_Session from "trpc-server/types/next-auth";

interface ProtectedPageProps {
    children: ReactNode;
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    mainActions?: ReactNode;
}

const ProtectedPage: FC<ProtectedPageProps> = ({
    children,
    title,
    subtitle,
    mainActions,
}) => {
    const router = useRouter();
    const session = useSession();

    if (session.status === "loading") {
        return <LoadingScreen />;
    }

    handleRedirects(router, session);

    return (
        <>
            <Head>
                <title>
                    {APP_NAME}
                    {router.pathname !== "/" ? `| ${title}` : ""}
                </title>
            </Head>
            <AppPage>
                <MainLayout
                    title={title}
                    subtitle={subtitle}
                    mainActions={mainActions}
                >
                    {children}
                </MainLayout>
            </AppPage>
        </>
    );
};

const handleRedirects = (
    router: NextRouter,
    session?: { data?: I_Session | null; status: string },
) => {
    if (isMobile) {
        router.push("/mobile");
    }
    if (session?.status === "unauthenticated") {
        if (
            LocalStorageHelper.ID_TOKEN.get() ||
            LocalStorageHelper.REFRESH_TOKEN.get()
        ) {
            LocalStorageHelper.clearAll();
        }
        router.push("/login");
        return;
    }

    if (
        session &&
        !session.data?.stale_team &&
        router.pathname !== "/welcome"
    ) {
        router.push("/welcome");
        return;
    }

    if (session?.data?.user) {
        if (router.pathname === "/") {
            router.push("/integrations/unified");
            return;
        }
    }
};

export default ProtectedPage;
